import axios, { AxiosInstance } from 'axios';
interface LoginRequest {
  email: string;
  password: string;
}

interface SignupRequest {
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  phone?: string;
}

interface ForgotPasswordRequest {
  email: string;
}

interface ResendEmailVerificationRequest {
  email: string;
}

interface AuthResponse {
  accessToken: string;
}

interface VerifyEmailRequest {
  token: string
}
interface resetPasswordRequest {
  password: string;
  confirmPassword: string;
  token: string;
}
interface ApiError {
  status: number;
  Errormessage: string;
}
const apiClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND,
  headers: {
    'Content-Type': 'application/json',
  },
});

interface ContactRequest {
  name: string;
  email: string;
  message: string;
}


export async function SencContactMessage(data: ContactRequest) {
  try {
    const response = await apiClient.post<ContactRequest>('/api/mail/sendContactEmail', data);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Login failed');

  }
}

export async function login(data: LoginRequest): Promise<AuthResponse> {
  try {
    const response = await apiClient.post<AuthResponse>('/api/auth/signin', data);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Login failed');

  }
}

export async function signup(data: SignupRequest) {
  try {
    const response = await apiClient.post('/api/auth/signup', data);

    return response.data;
  } catch (error: any) {
    return {
      status: error.response?.status || 500,
      Errormessage: error.response?.data?.message || 'sign up failed',
    } as ApiError;;
  }
}

export async function forgotPassword(data: ForgotPasswordRequest): Promise<void> {
  try {
    await apiClient.post('/api/auth/forgot-password', data);
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to send password reset email');
  }
}

export async function resendEmailVerification(data: ResendEmailVerificationRequest): Promise<void> {
  try {
    await apiClient.post('/api/auth/resend-verification', data);
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to resend verification email');
  }
}
export async function VerifyEmail(data: VerifyEmailRequest) {
  try {
    await apiClient.post('/api/auth/verify-email', data);
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Token Invalid or Expired !');
  }
}
export async function resetPassword(data: resetPasswordRequest) {
  try {
    const results = await apiClient.post('/api/auth/reset-password', data);
    return results.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Token Invalid or Expired !');
  }
}
export async function forgetPassword(data: VerifyEmailRequest) {
  try {
    const results = await apiClient.post('/api/auth/forget-password', data);
    return results.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Token Invalid or Expired !');
  }
}